export default __webpack_public_path__ + "static/media/87.97b94d74.jpg";